import(/* webpackMode: "eager" */ "/vercel/path0/app/careers/page.tsx")